import React, { useState } from 'react';
import ReactModal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import language from '@language';
import { termsCl } from '../../bank-transfer/form/terms-cl';

ReactModal.setAppElement('body');

const Form = ({ errors, sending, showValidations, errorMessage, onChange, onSubmit, fields }) => {
    
    const [showModal, setShowModal] = useState(false);

    const handleFieldChange = (event) => {
        const fieldName = event.target.name;
        const fieldValue = event.target.value;

        let newFields = {
            ...fields,
            [fieldName]: fieldValue
        };

        if (['conditions'].indexOf(fieldName) !== -1) {
            newFields = {
                ...newFields,
                conditions: !fields.conditions
            };
        }
        onChange(newFields);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(fields);
    };

    const showTerms = (e) => {
        e.preventDefault();
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const getTerms = () => {
        return { __html: termsCl };
    };

    return (
        <div className="bank-transfer khipu">
            {sending && (
                <div className="overlay">
                    <div className="loader" />
                </div>
            )}
            {errorMessage && (
                <div id="error-box" className="error-box">
                    <p>{errorMessage}</p>
                </div>
            )}

            <form
                id="dd-form"
                onSubmit={handleSubmit}
                className={`${showValidations ? 'sended' : ''}`}
            >
                <div className="row-input">
                    {/*client_number*/}
                    <div className={`input ${errors?.['client_number'] ? 'invalid' : ''}`}>
                        <label>{language.client_number}</label>
                        <input
                            name="client_number"
                            type="text"
                            value={fields.client_number}
                            onChange={handleFieldChange}
                            maxLength={8}
                        />
                        {errors?.['client_number'] && <div className="error-tooltip">{errors['client_number']}</div>}
                    </div>

                    {/*property_number*/}
                    <div className={`input ${errors?.['property_name'] ? 'invalid' : ''}`}>
                        <label>{language.property_name}</label>
                        <input 
                            name="property_name" 
                            value={fields.property_name} 
                            type="text" 
                            onChange={handleFieldChange} 
                        />
                    </div>
                </div>

                <div className="row-input">
                    {/*holder_name*/}
                    <div className={`input ${errors?.['holder_name'] ? 'invalid' : ''}`}>
                        <label>{language.holder_name}</label>
                        <input
                            value={fields.holder_name}
                            name="holder_name"
                            type="text"
                            onChange={handleFieldChange}
                        />
                    </div>

                    {/*cuil*/}
                    <div className={`input ${errors?.['document'] ? 'invalid' : ''}`}>
                        <label>{language.document}</label>
                        <input
                            value={fields.document}
                            name="document"
                            type="text"
                            onChange={handleFieldChange}
                        />
                        {errors?.['document'] && <div className="error-tooltip">{errors['document']}</div>}
                    </div>
                </div>

                <div className="row-input">
                    {/*email*/}
                    <div className={`input ${errors?.['email'] ? 'invalid' : ''}`}>
                        <label>{language.email}</label>
                        <input
                            value={fields.email}
                            name="email"
                            type="text"
                            onChange={handleFieldChange}
                        />
                    </div>
                </div>

                <div className="row-input">
                    {/*invoice_number*/}
                    <div className={`input ${errors?.['invoice_number'] ? 'invalid' : ''}`}>
                        <ReactTooltip id="invoice_number" place="top" type="dark" effect="solid">
                            <span>{language.invoice_disclaimer}</span>
                        </ReactTooltip>
                        <label>
                            <span>
                                {language.invoice_number} <a className="info" data-tip data-for="invoice_number" />
                            </span>
                        </label>
                        <input
                            value={fields.invoice_number}
                            name="invoice_number"
                            type="text"
                            onChange={handleFieldChange}
                            maxLength={109}
                        />
                        {errors?.['invoice_number'] && (
                            <div className="error-tooltip">{errors['invoice_number']}</div>
                        )}
                    </div>

                    {/*amount*/}
                    <div className={`input ${errors?.['amount'] ? 'invalid' : ''}`}>
                        <label>{language.amount}</label>
                        <div className="group">
                            <span className="symbol">$</span>
                            <input
                                value={fields.amount}
                                className="small"
                                name="amount"
                                maxLength={15}
                                type="text"
                                onChange={handleFieldChange}
                            />
                        </div>
                        {errors?.['amount'] && <div className="error-tooltip">{errors['amount']}</div>}
                    </div>

                    <div className="row-input">
                        <div className="conditions">
                            <label>
                                <input 
                                    type="checkbox" 
                                    onChange={handleFieldChange} 
                                    name="conditions"
                                    checked={fields.conditions}
                                />{' '}
                                {language.terms_1}{' '}
                                <a onClick={showTerms} href="#">
                                    {language.terms_2}
                                </a>
                            </label>
                            <ReactModal
                                isOpen={showModal}
                                contentLabel="Minimal Modal Example"
                                className="terms_modal"
                            >
                                <div dangerouslySetInnerHTML={getTerms()} />
                                <button onClick={handleCloseModal}>{language.close}</button>
                            </ReactModal>
                        </div>
                    </div>
                </div>

                <div className="submit">
                    <button type="submit">{language.send}</button>
                </div>
            </form>
        </div>
    );
};

export default Form;
